import {
  Component,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';

interface LanguageItem {
  id: number;
  name: string;
}

@Component({
  selector: 'app-language',
  standalone: false,
  templateUrl: './language.html',
  styleUrl: './language.scss',
})
export class Language implements OnInit{
   pageTitle = 'Language List';

  pageSubtitle =
    'View, manage, and organize all course languages in one place.';

  searchTerm = '';

  page = 1;
  pageSize = 10;

  languages: LanguageItem[] = [
    {
      id: 1,
      name: 'Arabic',
    },
    {
      id: 2,
      name: 'Bangla',
    },
    {
      id: 3,
      name: 'English',
    },
    {
      id: 4,
      name: 'Hindi',
    },
    {
      id: 5,
      name: 'Spanish',
    },
  ];

  filteredLanguages: LanguageItem[] = [];

  constructor(
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.applyFilters();
  }

  get paginatedLanguages(): LanguageItem[] {
    const startIndex =
      (this.page - 1) * this.pageSize;

    const endIndex =
      startIndex + this.pageSize;

    return this.filteredLanguages.slice(
      startIndex,
      endIndex
    );
  }

  get startItem(): number {
    if (
      this.filteredLanguages.length === 0
    ) {
      return 0;
    }

    return (
      (this.page - 1) * this.pageSize + 1
    );
  }

  get endItem(): number {
    return Math.min(
      this.page * this.pageSize,
      this.filteredLanguages.length
    );
  }

  onSearchChange(): void {
    this.page = 1;
    this.applyFilters();
  }

  onPageSizeChange(event: Event): void {
    const selectElement =
      event.target as HTMLSelectElement;

    this.pageSize = Number(
      selectElement.value
    );

    this.page = 1;
  }

  applyFilters(): void {
    const normalizedSearch =
      this.searchTerm
        .trim()
        .toLowerCase();

    this.filteredLanguages =
      this.languages.filter((language) =>
        language.name
          .toLowerCase()
          .includes(normalizedSearch)
      );

    const lastAvailablePage = Math.max(
      1,
      Math.ceil(
        this.filteredLanguages.length /
          this.pageSize
      )
    );

    if (this.page > lastAvailablePage) {
      this.page = lastAvailablePage;
    }
  }

  clearFilters(): void {
    this.searchTerm = '';
    this.page = 1;

    this.applyFilters();
  }

  addLanguage(): void {
    this.router.navigate([
      '/admin/course-reference/add-language'
    ]);
  }

  editLanguage(
    language: LanguageItem
  ): void {
    this.router.navigate([
      '/admin/course-reference/language/edit',
      language.id
    ]);
  }

  deleteLanguage(
    language: LanguageItem
  ): void {
    console.log(
      'Delete language:',
      language
    );
  }

  trackByLanguageId(
    _index: number,
    language: LanguageItem
  ): number {
    return language.id;
  }
}
